import { helper } from '@ember/component/helper';
import pluralize from 'cio/utils/pluralize';
import { TIMEFRAME_UNITS, roundTimeframe, findRoundUnit } from 'cio/utils/round-timeframe-units';

export function timeframeUnit([seconds], { defaultUnitWhenZero = null }) {
  let timeframe = roundTimeframe(seconds);
  let unit = findRoundUnit(timeframe);

  if (timeframe === 0 && defaultUnitWhenZero) {
    unit = TIMEFRAME_UNITS.findBy('value', defaultUnitWhenZero);
  }

  let value = Math.ceil(timeframe / unit.seconds);
  return `${value} ${pluralize(value, unit.value)}`;
}

export default helper(timeframeUnit);
